import { render } from "./ChatToast.vue?vue&type=template&id=971ef372&scoped=true"
import script from "./ChatToast.vue?vue&type=script&lang=js"
export * from "./ChatToast.vue?vue&type=script&lang=js"

import "./ChatToast.vue?vue&type=style&index=0&id=971ef372&lang=scss&scoped=true"

import exportComponent from "/Users/ferlando/Desktop/Baboon/baboon-pos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-971ef372"]])

export default __exports__